__turbopack_context__.v({
  "className": "aIutgG_className",
});
